// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"610d7f46","160":"0ead112d","208":"45efbe9a","293":"b94237bf","453":"dc48957d","516":"2e70f2c8","519":"cbca444a","917":"c5eb4088","946":"ed16b464"}[chunkId] + ".chunk.js";
};